import moment from 'moment';

export const calcTotal = (data, costType) => {
  return data.reduce((acc, cur) => {
    const result = cur.date.reduce((acc, cur) => {
      return acc + cur[costType];
    }, 0);

    return acc + result;
  }, 0);
};

/**
 * Calc date range
 */

/**
 * return Range by days
 * @param days {number}
 * @param end {Date}
 * @return {{start: Date, end}}
 */
export const rangeByDays = (days, end) => {
  const start = moment(end)
    .subtract(days, 'days')
    .toDate();

  return {
    start: start,
    end: end,
  };
};

export const yearToDate = maxDate => {
  const start = moment(maxDate)
    .startOf('year')
    .toDate();

  const end = maxDate;

  return {
    start: start,
    end: end,
  };
};

export const monthToDate = maxDate => {
  const start = moment(maxDate)
    .startOf('month')
    .toDate();

  const end = maxDate;

  return {
    start: start,
    end: end,
  };
};

export const days7 = maxDate => {
  const start = moment(maxDate)
    .subtract(7, 'days')
    .toDate();

  const end = maxDate;

  return {
    start: start,
    end: end,
  };
};

export const days14 = maxDate => {
  const start = moment(maxDate)
    .subtract(14, 'days')
    .toDate();

  const end = maxDate;

  return {
    start: start,
    end: end,
  };
};

export const days30 = maxDate => {
  const start = moment(maxDate)
    .subtract(30, 'days')
    .toDate();

  const end = maxDate;

  return {
    start: start,
    end: end,
  };
};

export const days90 = maxDate => {
  const start = moment(maxDate)
    .subtract(90, 'days')
    .toDate();

  const end = maxDate;

  return {
    start: start,
    end: end,
  };
};

export const days180 = maxDate => {
  const start = moment(maxDate)
    .subtract(180, 'days')
    .toDate();

  const end = maxDate;

  return {
    start: start,
    end: end,
  };
};

export const lastMonth = () => {
  const start = moment()
    .subtract(1, 'months')
    .startOf('month')
    .toDate();

  const end = moment()
    .subtract(1, 'months')
    .endOf('month')
    .toDate();

  return { start: start, end: end };
};

export const month1 = () => {
  const start = moment()
    .subtract(1, 'months')
    .startOf('month')
    .toDate();

  const end = moment()
    .subtract(1, 'months')
    .endOf('month')
    .toDate();

  return {
    start: start,
    end: end,
  };
};

export const month3 = () => {
  const start = moment()
    .subtract(3, 'months')
    .startOf('month')
    .toDate();

  const end = moment()
    .subtract(1, 'months')
    .endOf('month')
    .toDate();

  return {
    start: start,
    end: end,
  };
};

export const month6 = () => {
  const start = moment()
    .subtract(6, 'months')
    .startOf('month')
    .toDate();

  const end = moment()
    .subtract(1, 'months')
    .endOf('month')
    .toDate();

  return {
    start: start,
    end: end,
  };
};

export const year1 = maxDate => {
  const start = moment(maxDate)
    .subtract(12, 'month')
    .startOf('month')
    .toDate();

  const end = maxDate;

  return {
    start: start,
    end: end,
  };
};

export const rangeByType = (type, maxDate) => {
  switch (type) {
    case 'ytd':
      return yearToDate(maxDate);
    case 'mtd':
      return monthToDate(maxDate);
    case '7days':
      return days7(maxDate);
    case '14days':
      return days14(maxDate);
    case '30days':
      return days30(maxDate);
    case '90days':
      return days90(maxDate);
    case '180days':
      return days180(maxDate);
    case 'lastMonth':
      return lastMonth();
    case '1month':
      return month1();
    case '3months':
      return month3();
    case '6months':
      return month6();
    case '1year':
      return year1(maxDate);
    default:
      return { start: null, end: null };
  }
};
